import type { Margins, Measure, SpatialRectangle } from "#public"

import { GetXY } from "./GetXY"

/**
 * The gap between a rect and one nested inside it, per edge — the inverse of
 * `AddMargins`, so `AddMargins(inner, MarginsBetween(outer, inner))` is
 * `outer` again. Edges where `inner` pokes outside `outer` come back negative;
 * clamp at the call site if that isn't meaningful there.
 *
 * `top` is the higher `y`: y grows up.
 */
export const MarginsBetween = <T extends Measure>(
  outer: SpatialRectangle<T>,
  inner: SpatialRectangle<T>
): Margins<T> => {
  const o = GetXY(outer)
  const i = GetXY(inner)
  return {
    top: (o.y2 - i.y2) as T,
    right: (o.x2 - i.x2) as T,
    bottom: (i.y1 - o.y1) as T,
    left: (i.x1 - o.x1) as T,
  }
}
